/**
 * Google Meet integration documentation page
 */

import {DocsContent} from '../../../components/docs/DocsContent';
import {DocsActionButtons} from '../../../components/docs/DocsActionButtons';

export function GoogleMeetIntegration() {
  return (
    <DocsContent
      title="Google Meet Integration"
      description="Connect VoxaPilot with Google Meet to automatically transcribe your meetings."
    >
      <div className="space-y-8">
        <section>
          <h2 className="text-2xl font-bold text-textPrimary mb-4">Overview</h2>
          <p className="text-textSecondary mb-4">
            VoxaPilot integrates with Google Meet to automatically record and transcribe your
            meetings. Connect your Google account to get started.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-textPrimary mb-4">Setup</h2>

          <h3 className="text-xl font-semibold text-textPrimary mb-3 mt-6">Step 1: Connect Google Account</h3>
          <ol className="list-decimal list-inside space-y-2 text-textSecondary mb-6">
            <li>Go to Settings → Integrations</li>
            <li>Click "Connect Google Meet"</li>
            <li>Sign in with your Google account</li>
            <li>Grant VoxaPilot access to Google Calendar and Meet</li>
          </ol>

          <h3 className="text-xl font-semibold text-textPrimary mb-3 mt-6">Step 2: Enable Calendar Integration</h3>
          <p className="text-textSecondary mb-4">
            VoxaPilot uses Google Calendar to detect meetings and automatically join them for
            transcription.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-textPrimary mb-4">Features</h2>
          <ul className="list-disc list-inside space-y-2 text-textSecondary mb-6">
            <li>Automatic meeting detection from Google Calendar</li>
            <li>Real-time transcription during meetings</li>
            <li>Automatic participant identification</li>
            <li>Meeting metadata sync</li>
          </ul>
        </section>

        <DocsActionButtons pageTitle="Google Meet Integration" />
      </div>
    </DocsContent>
  );
}

